import React, { Fragment, useState, useEffect } from "react";
import { connect } from 'react-redux';
import { loginSuccess, setUser } from '../redux/actions/LoggedInAction';
import Topbar from "../layouts/TopBar";
import Footer from "../layouts/Footer";
import toast from 'react-hot-toast';
import LocationResources from "../resources/LocationResources";
import UserResources from "../resources/UserResources";
import RotaResources from "../resources/RotaResources";
import Select from 'react-select';
import moment from "moment";
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

function validate(email, password, confirm_password) {
    return {
      email: email.length === 0,
      password: password.length === 0,
      confirm_password: confirm_password.length === 0,
    };
  }

function MemberPassowordReset({loginSuccess, setUser}){   
    const [isTokenValid, setIsTokenValid] = useState(false);
    const token = new URLSearchParams(window.location.search).get('token')
    const user_email = new URLSearchParams(window.location.search).get('email')

      const [formData, setformData] = useState({
        email: '',
        password: '',
        confirm_password: '',
        token: token
      });
    
    
    const userResources = new UserResources()
    const today = new Date();
       
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setformData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };

      
    const canBeSubmitted = (dataToSubmit) => {
        const errors = validate(dataToSubmit['email'], dataToSubmit['password'], dataToSubmit['confirm_password']);
        const isDisabled = Object.keys(errors).some(x => errors[x]);
        return !isDisabled;
    }

    const passwordQualityCheck = (password) => {
        // At least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character
        const passwordRegex = /^(?=.*[A-Z])(?=.*[@$!%*?&#_])[A-Za-z\d@$!%*?&#_]{8,}$/;
;
        return passwordRegex.test(password);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.password !== formData.confirm_password) {
            toast.error("Passwords do not match.");
            return;
        }
        
        if (!isTokenValid) {
            toast.error("Invalid or expired token, request a new password reset.");
            return;
        }

        if (!passwordQualityCheck(formData.password)) {
            toast.error("Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.");
            return;
        }

        if (!canBeSubmitted(formData)){
            toast.error("Fill out all the fields")
            return
        }
        userResources.user_pwd_reset_post(formData).then(res => {
            if (res.error.length < 1) {
                toast.success("Password Reset Successfully, please login with your new password.");
                setTimeout(() => {
                    window.location.href = window.location.origin + '/registration';
                  }, 200);
            }else if(res.error === 'Record not found') {
                toast.error("Unknown user record.")
            }
            else {
                toast.error("Reset failed, ensure you use the same email as when you registered.")
            }
            }).catch((err) => {
                toast.error("Network Error: " + err);
            });

       
      };

    useEffect(() => {
        userResources.get_verify_reset_password_token(token, user_email).then(res => {
            if (res.error.length < 1) {    
                setIsTokenValid(res['body']['valid']); }
            else {
                toast.error("Invalid or expired token, request a new password reset.");
                setIsTokenValid(false);
            }}).catch((err) => {
                toast.error("Network Error: " + err);
            });
        
    }, []);
    

    return(
        <Fragment>
            <Topbar/>

            <div className="hero-area">
            {/* <div className="page-banner parallax" style={{backgroundImage: "url(assets/images/testjpeg1280.jpg)"}}> */}
            <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">
                        <div className="page-banner-text">
                            <h1 style={{color:"#ffa800"}} className="block-title"><strong>Enter a new password</strong></h1>
                        </div>
                    </div>
                </div>
            </div>

            <div className="spacer-10"></div>

            {/* <!-- Main Content --> */}
            <div id="main-container">
                <div className="content">
                        <div className="text-align-center">
                            <h2>Password Reset</h2>
                        </div>
                <div className="container" id="openings" style={{alignItems:"center"}} >                        
                        <div className="col-md-12" style={{alignItems:"center"}}>                	
                            <div className="col-md-10 col-sm-10 mx-auto">
                                <div className="well widget widget_volunteer_form">
                                <form onSubmit={handleSubmit}>                                    
                                    <div className="row">                                        
                                        
                                        <div className="spacer-20"></div>
                                            <label>Email<span style={{color:"red"}}>*</span></label>
                                            <input type="email" className="form-control"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                            />                                                                          
                                    </div> 
                                    <div className="spacer-20"></div>
                                    <div className="row">                                     
                                        
                                            <label>Choose New Password<span style={{color:"red"}}>*</span></label>
                                            <input type="password" className="form-control"
                                                name="password"
                                                value={formData.password}
                                                onChange={handleInputChange}
                                            />                                                                          
                                    </div>
                                    <div className="spacer-20"></div>
                                    <div className="row"> 
                                            <label>Re enter Password<span style={{color:"red"}}>*</span></label>
                                            <input type="password" className="form-control"
                                                name="confirm_password"
                                                value={formData.confirm_password}
                                                onChange={handleInputChange}
                                            />
                                    </div>
                                        <div className="spacer-30"></div>                                        
                                        <input style={{backgroundColor:"#003165"}} type="submit" className="btn btn-primary" value="Submit"/>
                                        <div className="spacer-10"></div>
                                </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="spacer-20"></div>
                    <div className="spacer-40"></div>
                              
                  
                    
                </div>
            </div>

            <Footer/>     
        </Fragment>
    )
}

const mapDispatchToProps = {
    loginSuccess,
    setUser,
};

export default connect(null, mapDispatchToProps)(MemberPassowordReset);
